import { render, staticRenderFns } from "./Training.vue?vue&type=template&id=4503bf06&"
import script from "./training.js?vue&type=script&lang=js&"
export * from "./training.js?vue&type=script&lang=js&"
import style0 from "./Training.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports